// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.rowCell[data-v-2d2f190b] {\r\n    height: 48px;\r\n    vertical-align: middle;\r\n    overflow: hidden;\r\n    padding-top: 5px;\n}\n.riga-diversa-in-altra-distinta[data-v-2d2f190b] {\r\n    background-color: lightsteelblue;\n}\n.riga-assente-in-altra-distinta[data-v-2d2f190b] {\r\n    background-color: orange;\n}\r\n", ""]);
// Exports
module.exports = exports;
